import React from "react";

const FacebookReviewsIframe = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "800px", // limit width but not height
        // border: "1px solid #e0e0e0",
        // borderRadius: "12px",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        margin: "0 auto",
        overflow: "hidden", // prevents unwanted scrollbars
      }}
    >
      <iframe
        // src="https://widgets.sociablekit.com/facebook-page-reviews/iframe/25604167"
        src="https://widgets.sociablekit.com/facebook-page-reviews/iframe/25614348"
        style={{
          width: "100%",
          minHeight: "600px", // give it a generous starting height
          border: "none",
        }}
        frameBorder="0"
        scrolling="auto" // allow iframe to scroll internally if needed
        allowFullScreen
        title="Facebook Page Reviews"
      />
    </div>
  );
};

export default FacebookReviewsIframe;
